<form
    (ngSubmit)="onSearch(formObj)"
    #formObj="ngForm"
    #formElRef
    class="gtm-search-external-form"
    appClickOutside
    (clickOutside)="closeSuggestions()"
    [ngClass]="{
        'header-search selenium-search-header': type === 'for-header',
        'home-search': type === 'for-browse',
        'error-search': type === 'for-error',
    }"
    autocomplete="off"
>
    <input
        #formInput
        type="text"
        class="external-search-input form-control"
        placeholder="{{ placeholder || 'Start a new search' }}"
        name="q"
        role="combobox"
        aria-autocomplete="list"
        aria-label="Start a new search"
        [attr.aria-expanded]="isAnyMenuOpen"
        [attr.aria-controls]="instanceId + '-search-listbox'"
        [attr.aria-activedescendant]="activeDescendantId"
        [attr.title]="formObj.value?.q || null"
        ngModel
        autocomplete="off"
        (ngModelChange)="onInputChange($event)"
        (keydown)="onInputKeydown($event)"
        (focus)="onFocusOrClick(formObj.value?.q || null)"
        (click)="onFocusOrClick(formObj.value?.q || null)"
        (blur)="onInputBlur($event)"
    />
    <app-search-suggestions-dropdown
        #suggestionsDropdownRef
        *ngIf="isAutocompleteEnabled"
        [idPrefix]="instanceId"
        [suggestions]="suggestions"
        [isOpen]="isSuggestionsOpen"
        [activeIndex]="activeSuggestionIndex"
        [searchTerm]="formObj.value?.q"
        (searchSuggestionSelected)="onSelectSearchSuggestion($event)"
        (documentSelected)="onSelectDocument($event)"
        (viewAllResults)="onViewAllResults($event)"
        (viewAllBlur)="onSuggestionsDropdownBlur($event)"
    ></app-search-suggestions-dropdown>
    <app-search-popular-dropdown
        [idPrefix]="instanceId"
        [popularSearches]="popularSearches"
        [isOpen]="isPopularOpen"
        [activeIndex]="activePopularIndex"
        [showPopularHeading]="showPopularHeading"
        (popularSearchSelected)="onSelectPopularSearch($event)"
    ></app-search-popular-dropdown>
    <button
        #submitBtn
        class="btn btn-primary selenium-external-search-button"
        [ngClass]="{ 'button-text': buttonText }"
        aria-label="Search"
        type="submit"
        (blur)="onSubmitButtonBlur($event)"
    >
        <span *ngIf="buttonText">{{ buttonText || "" }}</span>
        <app-icon class="icon search-icon" [type]="'Redesign-search'"></app-icon>
    </button>
</form>
